import { platformAlternateBg } from '../PlatformShared'
import PricingTable from './PricingTable'
import { pricingContainer, pricingSection, PricingHeading } from './Shared'
export default function PerPiecePricing({ data, onTalkToSales }) {
    return (
        <section className={`${pricingSection} ${platformAlternateBg}`}>
            <div className={pricingContainer}>
                <PricingHeading {...data} />
                <PricingTable
                    id="per-piece"
                    variant="perPiece"
                    label={data.title}
                    columns={[data.label, ...data.columns].map((label) => ({
                        label,
                    }))}
                    groups={data.groups}
                    onTalkToSales={onTalkToSales}
                />
                <p className="mx-auto mt-4 max-w-[640px] text-center text-xs leading-relaxed text-olm-gray">
                    {data.footnote} See{' '}
                    <a
                        href={data.link.href}
                        className="font-bold text-secondary hover:underline">
                        {data.link.label}
                    </a>{' '}
                    {data.footnoteEnd}
                </p>
            </div>
        </section>
    )
}
